import { action } from '@storybook/addon-actions';
import { Meta, StoryObj } from '@storybook/react';

import { Guide } from './Guide';

const meta: Meta<typeof Guide> = {
  title: 'Guide',
  component: Guide,
  args: {
    onNextPhase: action('clicked'),
  },
};

export default meta;

type Story = StoryObj<typeof Guide>;

export const Basic: Story = {
  render: args => <Guide {...args} />,
};
